import React, {useContext, useState} from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";
import {Grid} from "@mui/material";
import CustomButton from "../../../../../components/CustomButton";
import Popup from "../../../../../components/WMS/Mobile/Popup";
import {PackingContext} from "../PackingOrderList/PackingContext";

MultiExpForceStopModal.propTypes = {

};

function MultiExpForceStopModal({open, handleClose}) {

    const {isMultiSessionPacking, handleForceStopMultiPackingSession} = useContext(PackingContext)

    return (
        <Popup
            open={open}
            onClose={handleClose}
            title={<FormattedMessage id={"wms.packing.modal.stopMultiExpSession.title"}/>}
            subtitle={<FormattedMessage id={"wms.packing.modal.stopMultiExpSession.subtitle"}/>}
            hideCloseIcon={isMultiSessionPacking}
            strictOnclose={isMultiSessionPacking}
        >
            <Grid
                container
                direction={"column"}
                gap={"8px"}
            >
                <CustomButton
                    fullWidth
                    onClick={() => {
                        handleClose()
                        handleForceStopMultiPackingSession()
                    }}
                    color={"lightRed"}
                >
                    <FormattedMessage id={"wms.packing.modal.scanWorkstation.stopMultiExpSession.button.confirm"}/>
                </CustomButton>
                <CustomButton
                    fullWidth
                    onClick={() => handleClose()}
                >
                    <FormattedMessage id={"wms.packing.modal.scanWorkstation.stopMultiExpSession.button.cancel"}/>
                </CustomButton>
            </Grid>
        </Popup>
    );
}

export default MultiExpForceStopModal;